import React from "react";
import { MDBCard, MDBCardImage } from "mdb-react-ui-kit";
import "../../css/MainInfoCard.css";

function MainInfoCard({
  isHeader,
  isEntity,
  logoImg,
  col1Num,
  overallGrade,
  overallGradeImg,
  overallScore,
  overallScoreColor,
}) {
  var roundedScore = String(Math.round(overallScore * 100));
  var background = `/grades/grade-${overallGrade}-circle.png`;
  return (
    <div className="mainInfoContainer">
      <div
        className={
          isHeader ? "mainInfoCardContainerHeader" : "mainInfoCardContainer"
        }
      >
        <MDBCard className="mainInfoLogoCard">
          <MDBCardImage className="mainInfoLogoImg" src={logoImg} alt="..." />
        </MDBCard>
        <MDBCard className="mainInfoInfoCard">
          <div className="mainInfoCardContent">
            <div
              className="mainInfoCol"
              style={{ borderRight: "1px solid var(--dark)" }}
            >
              <div className="mainInfoColContainer">{col1Num}</div>
              {isEntity ? (
                <p className="mainInfoText">Number of Assessed Individuals</p>
              ) : (
                <p className="mainInfoText">Total Entities Evaluated</p>
              )}
            </div>
            <div
              className="mainInfoCol"
              style={{ borderRight: "1px solid var(--dark)" }}
            >
              <div className="mainInfoColContainer">
                <img
                  className="mainInfoOverallCompImg"
                  src={overallGradeImg}
                  alt="..."
                />
              </div>
              <p className="mainInfoText">Overall Competency Level</p>
            </div>
            <div className="mainInfoCol">
              <div className="mainInfoColContainer">
                <div
                  className="mainInfoOverallScoreImg"
                  style={{
                    backgroundImage: `url(${background})`,
                  }}
                >
                  <div
                    className="mainInfoOverallAssessedText"
                    style={{ color: overallScoreColor }}
                  >
                    {roundedScore}
                  </div>
                </div>
              </div>
              <p className="mainInfoText">Overall Score</p>
            </div>
          </div>
        </MDBCard>
      </div>
      {isHeader && (
        <div className="gradeBarImageContainer">
          <img className="gradeBarImg" alt="grade bar" />
        </div>
      )}
    </div>
  );
}

export default MainInfoCard;
